module.exports = __webpack_public_path__ + "static/wingtips_logo-406c815b09c70de38266971038b67074.png";